module.exports = __webpack_public_path__ + "static/img/atte.ba00bd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/atte.jpg
// module id = Xcng
// module chunks = 3